import { render, staticRenderFns } from "./PublicationPage.vue?vue&type=template&id=3a7c691a&scoped=true&"
import script from "./PublicationPage.vue?vue&type=script&lang=js&"
export * from "./PublicationPage.vue?vue&type=script&lang=js&"
import style0 from "./PublicationPage.vue?vue&type=style&index=0&id=3a7c691a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c691a",
  null
  
)

export default component.exports